import * as React from 'react';
import { Input, InputProps, Label } from 'semantic-ui-react';

import * as rutUtils from './rut';

export interface RutProps extends InputProps {
    /**
     * Indica que el componente es requerido. Si no es requerido
     * el callback `esValido` reportará `true` si el campo está vacío,
     * en cambio si es requerido un campo vacío será reportado como
     * `false` en `esValido`.
     */
    requerido?: boolean;
    /**
     * El valor que tendrá el campo de texto. Debe venir formateado,
     * el RUT no se formateará automáticamente.
     * Este componente debe ser siempre controlado.
     */
    rut: string;
    /**
     * Callback que será invocado con el nuevo RUT ya formateado cada
     * vez que haya un cambio en el campo de texto. El callback será
     * invocado incluso si el texto no cambió (como al ingresar un
     * caracter no válido en el RUT).
     */
    alCambiarRut(rut: string): void;
    /**
     * Callback que será invocado cada vez que el campo de texto cambia
     * indicando si el RUT después de la edición es o no válido. Si el
     * campo es requerido un RUT vacío será evaluado como no válido.
     */
    esValido?(valor: boolean): void;
}

export const Rut: React.FunctionComponent<RutProps> = props => {
    const { requerido = false, rut, alCambiarRut, esValido, ...resto } = props;

    return (
        <Input
            {...resto}
            placeholder='12.345.678-9'
            type='text'
            value={rut}
            onChange={(_e, { value }) => {
                alCambiarRut(rutUtils.formatear(value));
                if (esValido) {
                    esValido(!rutEsInvalido(value, requerido));
                }
            }}
            required={requerido}
        >
            <input />

            {rutEsInvalido(rut) && (
                <Label color='red' pointing='left' size='tiny' floating>
                    Rut inválido
                </Label>
            )}
        </Input>
    );
};

export function rutEsInvalido(rut: string, requerido = false) {
    return rut.length > 0 ? !rutUtils.esValido(rut) : requerido;
}

export default Rut;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/RutPasaporte/componentes/Rut/index.tsx